const joinItems = <T extends { id: string }>(items: T[]): T[] => {
  const itemMap = items.reduce((result, airport) => {
    return result.set(airport.id, airport);
  }, new Map());
  return Array.from(itemMap.values());
};

export default joinItems;
